import App from './App.svelte'

// import { UnleashClient } from 'unleash-proxy-client';

// const unleash = new UnleashClient({
//     url: 'https://kurs.finance/feature-flags',
//     clientKey: 'default:production.0693c03a5bf9c80b0f30e9b0ca7656aff5e08eb54ca4f60d434363e5',
//     appName: 'kurs_druid',
// });

// Start the background polling
// unleash.start();
// unleash.on('ready', () => {
  // if (false) { // unleash.isEnabled('forte_informer')
  //     const banner1 = $('#google_3');
  //     console.log('forte_informer is enabled');
  //     if (document.body.clientWidth < 769) {
  //       banner1.css({"max-width":"350px", "height":"192px"}).html('<div style="max-width:350px; height:192px"><iframe src="https://bank.forte.kz/kurs-widget" width="100%" height="192" frameborder="no" scrolling="no" style="overflow:hidden"></iframe></div>');
  //     } else {
  //       const banner3 = $('#forte-widget');
  //       banner3.css({"max-width":"350px", "height":"192px"}).html('<div style="max-width:350px; height:192px"><iframe src="https://bank.forte.kz/kurs-widget" width="100%" height="192" frameborder="no" scrolling="no" style="overflow:hidden"></iframe></div>');
        
  //     }
  // } else {
  //     console.log('forte_informer is disabled');
  // }
  if (true) { //unleash.isEnabled('bcc_informer')// unleash.isEnabled('bcc_informer')
    console.log('bcc_informer is enabled');
      
  } else {
      console.log('bcc_informer is disabled');
  }
  
// });
// window.showKursTable = (props) => {
  const doc = document.getElementById('kurs-table')
  if (doc) {
    doc.innerHTML = '';
    const app = new App({
      target: doc,
    })
    if (document.body.clientWidth < 769) {
        setTimeout(() => {
          BccCurrenciesWidget.init({
            el: document.getElementById('table_3'),
            base: 'KZT',
            symbols: ['USD', 'EUR', 'GBP']
          })
        }, 50);
      } else {
          BccCurrenciesWidget.init({
            el: document.getElementById('currencies-wrap'),
            base: 'KZT',
            symbols: ['USD', 'EUR', 'GBP']
          })
      }
  } else{
    const archive = document.getElementById('kurs-table-archive')
    if(archive) {
      archive.innerHTML = '';
      const props = {archive: true}; 
      const app = new App({
        target: archive,
        props,
      });
    }
  }

// }
